<template>
  <div class="card card-custom gutter-b">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="card-title">
        <h3 class="card-label">Chi tiết tác vụ</h3>
      </div>
      <el-button type="primary" icon="el-icon-edit">Chấm bài</el-button>
    </div>

    <div class="card-body">
      <div class="row">
        <!-- Thông tin tác vụ -->
        <div class="col-md-8">
          <div class="border rounded p-4 bg-light">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label>Mã tác vụ</label>
                <el-input value="1057" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label>Loại tác vụ</label>
                <el-input value="Chấm speaking" disabled />
              </div>

              <div class="col-md-6 mb-3">
                <label>Hình thức test</label>
                <el-input value="Online" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label>Loại bài thi</label>
                <el-input value="Cuối khóa" disabled />
              </div>

              <div class="col-md-6 mb-3">
                <label>Thời gian bắt đầu thi</label>
                <el-input value="10:00:00 24/05/2024" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label>Thời gian kết thúc</label>
                <el-input value="12:30:00 25/05/2025" disabled />
              </div>

              <div class="col-md-6 mb-3">
                <label>Trung tâm</label>
                <el-input value="Trung tâm Anh ngữ IELTS Mentor" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label>Cơ sở</label>
                <el-input value="IELTS Mentor - Trần Đại Nghĩa" disabled />
              </div>

              <div class="col-md-6 mb-3">
                <label>Khóa học</label>
                <el-input value="Basic" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label>Họ và tên khách hàng</label>
                <el-input value="Tăng Phương Thảo" disabled />
              </div>

              <div class="col-md-6 mb-3">
                <label>Số điện thoại khách hàng</label>
                <el-input value="09653382651" disabled />
              </div>
              <div class="col-md-6 mb-3">
                <label>Trạng thái</label><br />
                <span class="badge badge-warning">Cần làm</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Kết quả bài test -->
        <div class="col-md-4">
          <label>Kết quả bài test</label>
          <div class="p-3 border rounded bg-light">Chưa có kết quả.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskDetail',
  data() {
    return {
      // Dữ liệu sẽ được bind từ API thật sau
    };
  },
  methods: {
    // TODO: thêm các hàm xử lý nếu cần
  }
};
</script>

<style scoped>
.badge-warning {
  background-color: #ffa500;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
}
</style>
